/**
 * Global configuration for HUD visual properties
 * These settings apply to all widgets in the HUD
 */
export interface HudGlobalConfig {
    /** Font family for all text elements */
    fontFamily: string;

    /** Base font size in pixels (widgets may scale relative to this) */
    baseFontSize: number;

    /** Primary line color in hex format (e.g., 0x00ff00 for green) */
    primaryLineColor: number;
}

/**
 * Default global configuration values
 */
export const DEFAULT_GLOBAL_CONFIG: HudGlobalConfig = {
    fontFamily: 'Arial',
    baseFontSize: 14,
    primaryLineColor: 0xffffff,
};
